import {
    BadRequestError,
    ForbiddenError,
    HttpError,
    ValidationFailuresResponse,
} from "components/ServerValidationErrors";

import { PartitionsApiUrl } from "env-config";
import { acquireAccessToken } from "./access-token-service";

const baseApiUrl = (): string => PartitionsApiUrl().replace(/[/]$/, "");

export async function apiFetch<TResponse>(path: string, options: RequestInit): Promise<TResponse> {
    const url = `${baseApiUrl()}${path}`;
    const accessToken = await acquireAccessToken("api://stock-partition-api", "access");
    const response = await fetch(url, {
        ...options,
        headers: { ...options.headers, Authorization: `Bearer ${accessToken}` },
    });
    if (response.ok) {
        if (response.status === 204) {
            return {} as TResponse;
        }
        if(response.status === 201) {
            return {} as TResponse;
        }
        const result = await response.json();
        return result as TResponse;
    } else if (response.status === 400) {
        throw new BadRequestError(
            response.status,
            response.statusText,
            (await response.json()) as ValidationFailuresResponse
        );
    } else if (response.status === 403) {
        throw new ForbiddenError(response.status, await response.text());
    } else {
        throw new HttpError(response.status, await response.text());
    }
}
